import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { get, getOr, join } from 'lodash/fp';
import qs from 'query-string';

import { ClasstingIcon } from '../../../../assets';

const S = {
  Content: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  IconWrapper: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
  `,
  Paragraph: styled.p`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${({ marginBottom }) => marginBottom};
    color: ${({ theme }) => theme.palette.grey[900]};
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
  `,
  Strong: styled.strong`
    text-align: center;
  `,
  Button: styled(Button)`
    margin-bottom: 0.75rem;
  `,
  Note: styled.p`
    font-size: 0.75rem;
    line-height: 1.5;
    color: ${({ theme }) => theme.palette.hexToRgb('#000', 0.38)};
  `,
  Link: styled(Link)`
    margin-left: 4px;
    text-decoration: underline;
  `,
};

const OpenLink = ({ guardianContactNewsletter, onClick }) => {
  const location = useLocation();
  const params = useParams();

  return (
    <S.Content>
      <S.IconWrapper>
        <ClasstingIcon />
      </S.IconWrapper>
      <S.Paragraph marginBottom="2.5rem">
        <S.Strong>
          {get('school.name', guardianContactNewsletter.data)}
        </S.Strong>
        <S.Strong>{get('title', guardianContactNewsletter.data)}</S.Strong>
        <span>
          클래스팅에서 간편하게 응답해보세요.
        </span>
      </S.Paragraph>
      <S.Button
        type="button"
        variant="outlined"
        color="secondary"
        onClick={onClick}
      >
        앱에서 열기
      </S.Button>
      <S.Note>
        앱 설치가 불가능하신가요?
        <S.Link
          to={{
            pathname: join('', [
              '/schools',
              `/${getOr('', 'school.sid', guardianContactNewsletter.data)}`,
              '/school-newsletters',
              `/${getOr('', 'newsletter_id', guardianContactNewsletter.data)}`,
            ]),
            search: `?${qs.stringify({
              gcid: getOr('', 'guardian_contact.id', guardianContactNewsletter.data),
              token: params.token,
            })}`,
            state: { from: location.pathname },
          }}
        >
          웹으로 보기
        </S.Link>
      </S.Note>
    </S.Content>
  );
};

OpenLink.propTypes = {
  guardianContactNewsletter: PropTypes.shape({
    data: PropTypes.shape({
      school: PropTypes.shape({
        name: PropTypes.string,
        title: PropTypes.string,
      }),
    }),
    loading: PropTypes.bool,
    error: PropTypes.instanceOf(Error),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default OpenLink;
